export default __webpack_public_path__ + "static/media/logo_novo.256a706d.png";